/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Theme does not handle sidebar menu language selector, following script dispatch a click event on the header language selector associated value */
document
  .querySelectorAll('#header-locale-popover-0 .Popover__ValueList button')
  .forEach((button, buttonIndex) => {
    button.addEventListener('click', (event) => {
      const headerPopOverButtons = document.querySelectorAll(
        '#header-locale-popover-1 .Popover__ValueList button'
      );

      const clickEvent = new MouseEvent('click');

      headerPopOverButtons[buttonIndex].dispatchEvent(clickEvent);
    });
  });

/* Theme is based on default cart form submission to get to the next step, I overwrite the logic with this script */
// const checkoutButtonClickHandler = (event) => {
//   event.preventDefault();

//   let checkoutButton = event.currentTarget;

//   // if (checkoutButton.hasAttribute('data-customer')) {
//   //   window.location.href = '/checkout';
//   // } else {
//   //   window.location.href = '/account/register';
//   // }

//   console.log(checkoutButton);
// };
